var map = {
	"./Alt1.svg": "ad3d",
	"./Alt2.svg": "f119",
	"./Alt3.svg": "72c9",
	"./Alt4.svg": "12cc",
	"./Altnews.svg": "f50c",
	"./Combined_Shape.svg": "34be",
	"./Exit.svg": "9092",
	"./Expenses-of-visiting.svg": "60bf",
	"./Group.svg": "295f",
	"./Group1.svg": "f08d",
	"./Group2.svg": "196a",
	"./Group3.svg": "0482",
	"./Group_98.svg": "6d28",
	"./MaskGroup(1).svg": "ba0e",
	"./MaskGroup(2).svg": "1ef1",
	"./Quantity-of-visitors.svg": "90aa",
	"./StatisticsRoutesAndAttractions.svg": "ce6b",
	"./Tourist-services.svg": "c889",
	"./Vector.svg": "e455",
	"./Vectorstatistics.svg": "c8f9",
	"./_2774131464368.svg": "565fe",
	"./_2808612491392.svg": "b5d5",
	"./_2808613807680.svg": "d751",
	"./about-icon-1.svg": "e838",
	"./about-icon-2.svg": "81ab",
	"./about-icon-3.svg": "e32d",
	"./about-icon-4.svg": "d176",
	"./about-icon-5.svg": "7eb3",
	"./about-icon-6.svg": "d6b3",
	"./about-system.svg": "f70e",
	"./adaptiveexit.svg": "98e0",
	"./admin-with-cogwheels.svg": "ee47",
	"./arrawDown.svg": "b739",
	"./arrawUp.svg": "f84b",
	"./arrow-big.svg": "dabf",
	"./arrow-left.svg": "ac3b",
	"./arrow-long-right.svg": "6809",
	"./arrow-right.svg": "cd8c",
	"./arrow_top.svg": "4e1c",
	"./arrowdown2-brown.svg": "5493",
	"./arrowdown2-white.svg": "6782",
	"./arrowdown2.svg": "2f75",
	"./arrowright-white.svg": "36d7",
	"./arrowright.svg": "fcf2",
	"./bar-chart-activ.svg": "63e4",
	"./bar_chart.svg": "6269",
	"./bar_chart_active.svg": "fc19",
	"./calendar.svg": "b8bd",
	"./cancel.svg": "b463",
	"./chat-open.svg": "0716",
	"./check.svg": "7bae",
	"./close.svg": "8b1b",
	"./countryFlag-Belarus.svg": "a9e1",
	"./countryFlag-China.svg": "92d0",
	"./countryFlag-Germany.svg": "e9ee",
	"./countryFlag-Kyrgyzstan.svg": "3aa2",
	"./countryFlag-Russia.svg": "46ca",
	"./countryFlag-Tajikistan.svg": "aae9",
	"./countryFlag-Turkey.svg": "4ab7",
	"./countryFlag-Ukraine.svg": "bb96",
	"./countryFlag-United_Kingdom.svg": "ad80",
	"./countryFlag-Uzbekistan.svg": "e8dc",
	"./createareport.svg": "c7ec",
	"./dagger.svg": "3e05",
	"./delete-parameter.svg": "f637",
	"./delete.svg": "0d45",
	"./diagram-1.svg": "6faa",
	"./donught-chart-activ.svg": "d283",
	"./doughnut_chart.svg": "1187",
	"./doughnut_chart_active.svg": "ec52",
	"./download-cloud.svg": "de7d",
	"./download.svg": "f28e",
	"./e-mail.svg": "4afc",
	"./edin_vmes.svg": "7e5d",
	"./excel-file.svg": "962c",
	"./header-right.svg": "224e",
	"./human.svg": "54d7",
	"./iconexpe.svg": "4dd7",
	"./iconmest.svg": "9635",
	"./imagePath.svg": "3892",
	"./input-eye.svg": "0e44",
	"./kazakh_tourism-dark.svg": "e4ec",
	"./kazakh_tourism.svg": "5128",
	"./kol_mest.svg": "ea10",
	"./kol_nomer.svg": "ad8f",
	"./kol_obs.svg": "bbde",
	"./koyko.svg": "cb54",
	"./line-chart-activ.svg": "47e3",
	"./line_chart.svg": "0305",
	"./line_chart_active.svg": "ed5f",
	"./logoTRS--footer.svg": "51bc",
	"./logoTRS.svg": "7d3b",
	"./magnifier.svg": "2d43",
	"./main-header-bg.svg": "b16d",
	"./man.svg": "407f",
	"./multi_chart.svg": "f53c",
	"./multi_chart_active.svg": "9efa",
	"./multiaxis-chart-activ.svg": "d2d6",
	"./number-of-visitors.svg": "1627",
	"./obem.svg": "16b0",
	"./obs_pos.svg": "0c91",
	"./obslujen.svg": "507d",
	"./pdf-file.svg": "140c",
	"./phone.svg": "c3bb",
	"./pie-chart-activ.svg": "3ed2",
	"./pie-chart.svg": "9773",
	"./pie_chart.svg": "d485",
	"./pie_chart_active.svg": "be31",
	"./questionIcon.svg": "9771",
	"./questionMark.svg": "0436",
	"./region.svg": "48fe",
	"./rollback.svg": "4519",
	"./search-blue.svg": "9ac9",
	"./search-icon.svg": "7669",
	"./search-normal.svg": "0576",
	"./show.svg": "b65e",
	"./statistics-accounting.svg": "00b0",
	"./sunburst-chart-activ.svg": "2ec4",
	"./sunburst_chart.svg": "0487",
	"./sunburst_chart_active.svg": "6092",
	"./teamwork.svg": "8a52",
	"./triangle-down.svg": "0f30",
	"./uploadfile.svg": "29f1",
	"./user.svg": "6aed",
	"./user_check.svg": "087a",
	"./user_circle.svg": "7745",
	"./woman.svg": "48dc",
	"./worldLocation.svg": "d35c",
	"./zap_gost.svg": "26ba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";